<div class="c-form c-form--highlight">

    <div ref:wrapper>
        {#if response && (response.code === 200 || response.code === 500) }
            <Message
                title="{ message.title }"
                actionText="{ message.action.text }"
                actionLink="{ message.action.link }"
            />
        {/if}

        {#if !response || (response && response.code === 400) }
            <form on:submit="submit(event)">
                <div class="c-form__header">
                    <h2 class="c-form__heading c-heading c-heading--small">
                        { heading }
                    </h2>

                    {#if response && response.code === 400 && response.data.errors["newsletter"] }
                        <!--
                        In theory, no real user should ever see this error message, but just in
                        case a legit user does get an error for some reason, there is a message
                        indicating something went wrong.
                        -->
                        <p class="c-form_errors">
                            There was an error submitting the form.
                        </p>
                    {/if}
                </div>

                {#each fields as [fieldId, field]}
                    <Field
                        id="{ fieldId }"
                        type="{ field.type }"
                        options="{ field }"
                        value="{ field.value || '' }"
                        {isLoading}
                        on:change="updateData(event.id, event.value)"
                        on:submit="submit()"
                    />
                {/each}
            </form>
        {/if}
    </div>

</div>

<script>
    import Field from './Field.html';
    import Message from './Message.html';
    import { getGclid } from '../../helpers/gclid.js';

    export default {

        components: {
            Field,
            Message,
        },

        data() {
            return {
                data: {},
                schema: [],
                heading: 'Loading…',
                messages: {},
                response: null,
                startedFormFillIn: false,
                csrfToken: null,
            }
        },

        computed: {
            fields: ({ schema, response }) => {
                return Object.entries(schema).map(([id, field]) => {
                    if(response && response.code === 400 && response.data.errors[id]) {
                        field.error = true;
                    } else {
                        field.error = false;
                    }

                    return [
                        id,
                        field
                    ];
                });
            },

            message: ({ response, messages }) => {
                if(response && response.code === 200) return messages.success;
                return messages.error;
            },
        },

        oncreate() {
            fetch(`/forms/${ window.pageSlug }`, {
                method: 'GET',
                credentials: 'same-origin',
            }).then((response) => {
                return response.json();
            }).then(({ data }) => {
                this.set({
                    schema: data.fields,
                    heading: data.heading,
                    messages: data.messages,
                    csrfToken: data.csrfToken,
                });
            });
        },

        methods: {

            updateData(id, value) {
                let data = this.get().data;

                if(data[id] !== value && !this.startedFormFillIn) {
                    this.fire('fillInStart');
                    this.startedFormFillIn = true;
                }

                data[id] = value;
                this.set({ data });
            },

            submit(e) {
                e.preventDefault();

                let form = new FormData();
                let data = this.get().data;

                this.fire('submit', { data });

                form.append('csrf_token', this.get().csrfToken);
                form.append('gclid', getGclid() || '');

                // Honeypot field
                form.append('website', '');

                Object.keys(data).map(function(key, index) {
                    form.append(key, data[key]);
                });

                this.set({ isLoading: true });

                fetch(`/forms/${ window.pageSlug }`, {
                    method: 'POST',
                    body: form,
                    credentials: 'same-origin',
                }).then((response) => {
                    return response.json();
                }).then((json) => {
                    this.animateStateChange({
                        isLoading: false,
                        response: json,
                    });
                });
            },

            animateStateChange(newState = {}) {
                const DURATION = 1000;

                let element = this.refs.wrapper;
                let oldState = this.get();

                // setup transitions
                element.style.transitionDuration = `${DURATION}ms, ${DURATION / 2}ms`;
                element.style.transitionProperty = 'height, opacity';
                element.style.transitionEasing = 'cubic-bezier(0.645, 0.045, 0.355, 1)';

                // save current height and temporarily replace state
                // to get new height
                let oldHeight = element.getBoundingClientRect().height;
                this.set(newState);
                let newHeight = element.getBoundingClientRect().height;

                // restore original state and fade out wrapper
                this.set(oldState);
                element.style.opacity = 1;
                window.setTimeout(() => {
                    element.style.opacity = 0;
                }, 1);

                // replace state and fade in again
                window.setTimeout(() => {
                    this.set(newState);
                    element.style.opacity = 1;
                }, DURATION / 2);

                // animate height change
                element.style.height = `${oldHeight}px`;
                window.setTimeout(() => {
                    element.style.height = `${newHeight}px`;
                }, 1);

                // clean up
                window.setTimeout(() => {
                    element.style.height = 'auto';
                    element.style.transition = 'none';
                }, DURATION);
            },

        },

    }
</script>
